// Import the Firebase modules you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

// ⚙️ Your web app's Firebase configuration
// 👉 Replace these placeholder values with your actual Firebase project config
const firebaseConfig = {
    apiKey: "AIzaSyCRMBTMqQTHnjvREaxPCzuFsUMNdNIL58A",
    authDomain: "piercing-2b103.firebaseapp.com",
    projectId: "piercing-2b103",
    storageBucket: "piercing-2b103.firebasestorage.app",
    messagingSenderId: "522182126756",
    appId: "1:522182126756:web:f5533ee3de419d32e94a31",
    measurementId: "G-H40MBXE94N"
};

// Initialize Firebase 
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);

// Export for use in components
export { db, storage, auth };

